const axios = require("axios");
import Vue from 'vue';

export const AUTH_HEADER = async () => {
	axios.interceptors.request.use(
		(config) => {
			if (
				config.url ===
					`${process.env.VUE_APP_API}${process.env.VUE_APP_TRUNGTUYEN}/upload` &&
				config.method == "post"
            ) {
				config.headers = {
					"Content-Type": "multipart/form-data",
				};
			} else {
				config.headers = {
					"Content-Type": "application/json",
					Accept: "application/json",
				};
			}

			return config;
		},
		(error) => {
      if (!error.response) {
        Vue.swal('Lỗi kết nối', 'Kiểm tra lại kết nối internet hoặc server đang gặp lỗi. Vui lòng thử lại sau ít phút', 'error');
      } else if (error.response.status === 408 || error.code === 'ECONNABORTED') {
        Vue.swal('Lỗi phía server', 'Server đang quá tải hoặc gặp lỗi. Vui lòng thử lại sau ít phút', 'error');
        console.error(`A timeout happend on url ${error.config.url}`);
      } else if (error.response.status === 500) {
        Vue.swal('Lỗi phía server', 'Lỗi xử lý phía server. Vui liên hệ admin để kiểm tra', 'error');
        console.error(`A error server on url ${error.config.url}`);
      }
      return Promise.reject(error)
    },
	);
};
